var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F2EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 28V29H8V28H34ZM21.5 13C22.1904 13 22.75 13.5596 22.75 14.25V15.75C22.75 15.8359 22.7413 15.9199 22.7248 16.0009L25.5 16C28.5376 16 31 18.4624 31 21.5V25.75C31 25.8359 30.9913 25.9199 30.9748 26.0009L32.75 26V27H9.25V26L11.0252 26.0009C11.0087 25.9199 11 25.8359 11 25.75V21.5C11 18.4624 13.4624 16 16.5 16L19.0252 16.0009C19.0087 15.9199 19 15.8359 19 15.75V14.25C19 13.5596 19.5596 13 20.25 13H21.5ZM25.5 17H16.5C14.0147 17 12 19.0147 12 21.5V25.75C12 25.8881 12.1119 26 12.25 26H14V21.75H15V26H29.75C29.8881 26 30 25.8881 30 25.75V21.5C30 19.0147 27.9853 17 25.5 17ZM21.5 14H20.25C20.1119 14 20 14.1119 20 14.25V15.75C20 15.8881 20.1119 16 20.25 16H21.5C21.6381 16 21.75 15.8881 21.75 15.75V14.25C21.75 14.1119 21.6381 14 21.5 14Z",
    fill: "#754FFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeFood);
export default __webpack_public_path__ + "static/media/free-food.f464bfd39be31b9370b6e14bd51a23e3.svg";
export { ForwardRef as ReactComponent };